<template>
  <div id="app" :class="deviceClass">
    <div v-if="isBrowserIE" class="not-supported" v-html="t('ie_not_supported')"></div>
    <router-view v-else/>
  </div>
</template>

<script>
import device from '@/utils/device';
import {isIE} from 'mobile-device-detect'

export default {
  computed: {
    deviceClass (){
      return device
    },
    isBrowserIE () {
      return isIE
    }
  }
}
</script>


<style lang="stylus">
// html,
// body
//   overflow: hidden
//   position: fixed

#app
  &.desktop
    height: 100vh
    overflow: hidden
    width: 100vw
  .not-supported
    background: #F4F4F4
    m-font-size(25,30)
    width 100%
    height 100%
    text-align center
    display absolute
    padding-top 100px

</style>
